/*--------------------------------------
SLIDER PRODUCTS LIST
 --------------------------------------*/
SliderProductsList = {
  init: function () {
    var swiper = new Swiper(".swiper-products-list", {
      freeMode: {
        enabled: false,
        sticky: true,
        momentumBounce: false

      },
      allowTouchMove: true,
      speed: 600,
      lazy: true, 
      slidesPerView: 2,
      slidesPerGroup: 2,
      grid: {
        rows: 2,
      },
      nextButton: '#button-next-product',
      prevButton: '#button-prev-product',
      navigation: {
        nextEl: ".swiper-button-next-product",
        prevEl: ".swiper-button-prev-product",
      },
      breakpoints: {
        "1435": {
          allowTouchMove: false,
          slidesPerView: "auto",
          grid: false,
          slidesPerGroup: 1,
        },
        "1025": {
          slidesPerView: "auto",
          grid: false,
          slidesPerGroup: 1,
        },
        "769": {
          slidesPerView: "auto",
          grid: false,
          slidesPerGroup: 1,
        }
      }
    });

    //INITIAL
    if ($(window).width() >= 1435) {
      $(".swiper-products-list img").on('dragstart', function () {
        return false
      })

      $('.swiper-products-list a').on('pointerdown',
        function pointerHandler(event) {
          window.location.href = $(this).attr('href');
        }
      );
    }

  }
};

/*--------------------------------------
SLIDER PRODUCTS APPEAR
 --------------------------------------*/
SliderProductsListAppear = {
  init: function () {

    $(".collection-item__title:first-child").addClass("item-collection-active");
    $(".collection-item-1").addClass("item-active");
    $(".collection-item-1 .collection-item__products").addClass("item-active-effect");
    $(".collection-item__title").click(function () {
      $(".collection-item__title").removeClass("item-collection-active");
      $(this).addClass("item-collection-active");
      var item_num = $(this).data('item-collection');
      $(".collection-item").removeClass("item-active");
      $(".collection-item-" + item_num).addClass("item-active");
      $(".collection-item .collection-item__products").removeClass("item-active-effect");
      setTimeout(function () {
        $(".collection-item-" + item_num + " .collection-item__products").addClass("item-active-effect");
      }, 100);
    });
  }
};



$(function () {
  SliderProductsList.init();
  SliderProductsListAppear.init();
});